export default {
  methods:{
    postAttrchg(){
      var form = document.createElement('form')
      form.action = process.env.VUE_APP_API_ATTR_CHANGE_URL
      form.method = 'POST'
      var q1 = document.createElement('input')
      var q2 = document.createElement('input')
      var q3 = document.createElement('input')
      var q4 = document.createElement('input')
      q1.type = 'hidden'
      q1.name = 'redirect_uri'
      q1.value = process.env.VUE_APP_API_ATTRCHK_REDIRECT_URL
      q2.type = 'hidden'
      q2.name = 'return_uri'
      q2.value = process.env.VUE_APP_API_ATTRCHK_REDIRECT_URL
      q3.type = 'hidden'
      q3.name = 'accordion_pattern'
      q3.value = '1'
      q4.type = 'hidden'
      q4.name = 'accordion_title_pattern'
      q4.value = '1'
      form.appendChild(q1)
      form.appendChild(q2)
      form.appendChild(q3)
      form.appendChild(q4)
      document.body.appendChild(form)
      form.submit()
    }
  }
}